import {
  IconBulb,
  IconCircleCheck,
  IconAlertCircle,
  IconArrowRight,
} from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import useRadialGauge from "../../../../hooks/useRadialGauge";
import { aiInsightsSnapshot } from "./data";
import { Link } from "react-router-dom";

const GAUGE_RADIUS = 15;

export default function InsightsTab({ onViewFullInsights, resetKey }) {
  const { circumference, offset, displayPercent } = useRadialGauge(
    GAUGE_RADIUS,
    aiInsightsSnapshot.matchScore,
    1200,
    resetKey,
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconBulb size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>AI Insights Snapshot</div>
            <div className={styles.cardSubtitle}>
              A quick look at what our AI has learned from your test and
              activity
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.aiTeaser}>
          <div className={styles.aiTeaserGauge}>
            <svg viewBox="0 0 36 36" width="88" height="88">
              <circle
                cx="18"
                cy="18"
                r={GAUGE_RADIUS}
                fill="none"
                stroke="#e2e8f4"
                strokeWidth="4"
              />
              <circle
                cx="18"
                cy="18"
                r={GAUGE_RADIUS}
                fill="none"
                stroke="#059669"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray={circumference.toFixed(2)}
                strokeDashoffset={offset.toFixed(2)}
                transform="rotate(-90 18 18)"
              />
              <text
                x="18"
                y="21"
                textAnchor="middle"
                fontSize="9"
                fontWeight="700"
                fill="#059669"
                fontFamily="Inter, sans-serif"
              >
                {displayPercent}%
              </text>
            </svg>
            <span className={styles.aiTeaserGaugeLabel}>
              AI Match
              <br />
              Score
            </span>
          </div>

          <div className={styles.aiTeaserHighlights}>
            <div className={styles.summaryGroup}>
              <div className={styles.summaryLabel}>
                <IconCircleCheck size={15} style={{ color: "#059669" }} /> Top
                Strengths
              </div>
              <div className={styles.pillList}>
                {aiInsightsSnapshot.strengths.map((s) => (
                  <span
                    className={`${styles.pill} ${styles.pillGreen}`}
                    key={s}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
            <div className={styles.summaryGroup}>
              <div className={styles.summaryLabel}>
                <IconAlertCircle size={15} style={{ color: "#b45309" }} />{" "}
                Growth Areas
              </div>
              <div className={styles.pillList}>
                {aiInsightsSnapshot.growthAreas.map((s) => (
                  <span
                    className={`${styles.pill} ${styles.pillAmber}`}
                    key={s}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardFooterLink}>
        <Link
          to="/ai-insights"
          className={styles.inlineLink}
        >
          View Full Insights <IconArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
